import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagSpecialistGroupProps {}

const ColorTagSpecialistGroup: React.FC<ColorTagSpecialistGroupProps> = props => {
  return <ColorTag className="ColorTagSpecialistGroup" color="#6B9162">Specialist</ColorTag>
}

export default ColorTagSpecialistGroup;